import { MediaIcon, RetailIcon, GovernmentIcon } from "./icons/index.js";
import { CRM_MINI_SITE_LINK, ENTERPRISE_PAGE_LINK, GOVERNMENT_PAGE_LINK, MEDIA_PAGE_LINK, RETAIL_PAGE_LINK, SERVICE_MINI_SITE_LINK, SMB_PAGE_LINK, SOFTWARE_MINI_SITE_LINK } from "constants/links";
const ENTERPRISE_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/AI%20homepage%202026/Menu2026-AIPlatfromMulti-product-Office-Building-Tall-2--Streamline-Ultimate.svg-Mj9mY.svg";
const SMB_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/AI%20homepage%202026/Menu2026-AIPlatfromMulti-product-smb-Cr9Hu.svg";
const CRM_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/AI%20homepage%202026/Menu2026-AIPlatfromMulti-product-crm-Lfwde.svg";
const SERVICE_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/AI%20homepage%202026/Menu2026-AIPlatfromMulti-product-svc-RKaZD.svg";
const DEV_ICON_URL = "https://dapulse-res.cloudinary.com/image/upload/AI%20homepage%202026/Menu2026-AIPlatfromMulti-product-Menu2026-AIPlatfromMulti-product-svc-RKaZD1-bJbzZ.svg";
export const COMPANY_SIZE_LINKS = [
    {
        iconUrl: ENTERPRISE_ICON_URL,
        title: "header.tabs.solution.enterprise.title",
        link: ENTERPRISE_PAGE_LINK,
        description: "header.tabs.solution.enterprise.description",
        text: "header.tabs.solution.enterprise"
    },
    {
        iconUrl: SMB_ICON_URL,
        title: "header.tabs.solution.smb.title",
        link: SMB_PAGE_LINK,
        description: "header.tabs.solution.smb.description"
    }
];
export const BUSINESS_APPLICATIONS_LINKS = [
    {
        iconUrl: CRM_ICON_URL,
        title: "header.tabs.products.mondaySalesCRM.title",
        description: "header.tabs.solution.businessApplications.crm.description",
        link: CRM_MINI_SITE_LINK,
        text: "footer.mondaySalesCRM"
    },
    {
        iconUrl: SERVICE_ICON_URL,
        title: "header.tabs.products.mondayService.title",
        description: "header.tabs.solution.businessApplications.service.description",
        link: SERVICE_MINI_SITE_LINK,
        text: "footer.mondayService"
    },
    {
        iconUrl: DEV_ICON_URL,
        title: "header.tabs.products.mondayDev.title",
        description: "header.tabs.products.dev.description",
        link: SOFTWARE_MINI_SITE_LINK,
        text: "footer.mondayDev"
    }
];
export const INDUSTRIES_LINKS = [
    {
        Icon: RetailIcon,
        text: "header.tabs.solution.retail",
        link: RETAIL_PAGE_LINK
    },
    {
        Icon: MediaIcon,
        text: "header.tabs.solution.media",
        link: MEDIA_PAGE_LINK
    },
    {
        Icon: GovernmentIcon,
        text: "header.tabs.solution.government",
        link: GOVERNMENT_PAGE_LINK
    }
];
